var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #e8ba3a;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 4px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        stroke: #193c34;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5.387096774194106,
    y: 5.129032258064399,
    width: 239.2258064516127,
    height: 199.7419354838712
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.629313745612308,
    y: 185.2278652701915,
    width: 206.7413725006245,
    height: 14.135345485370863,
    rx: 5.987483057841422,
    ry: 5.987483057841422
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.258798389771982,167.819324510961451c1.892929960509719,1.773014347139906,4.036204410042046,6.661296516949733,2.263190062907597,8.554226477459451-1.77301434713263,1.892929960511538-6.790913027456554,.073693644990271-8.683842987966273-1.699320702138721-1.892929960511538-1.773014347139906-2.309849052729987-5.044304403860224-.536834705597357-6.937234364369942s5.064557670144495-1.690685758081599,6.957487630656033,.082328589049212Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.55774480810578,
    y1: 176.52041136161097,
    x2: 41.99779248419691,
    y2: 179.27096708227145
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.736786578621832,167.819324510961451c-1.892929960511538,1.773014347139906-4.036204410043865,6.661296516949733-2.263190062904869,8.554226477459451,1.773014347129902,1.892929960511538,6.790913027448369,.073693644990271,8.683842987963544-1.699320702138721,1.892929960511538-1.773014347139906,2.309849052729987-5.044304403860224,.536834705593719-6.937234364369942-1.773014347128992-1.892929960509719-5.064557670140857-1.690685758081599-6.957487630652395,.082328589049212Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 45.437840160286214,
    y1: 176.52041136161097,
    x2: 41.99779248419691,
    y2: 179.27096708227145
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.99779248419691,
    y1: 185.22786526088203,
    x2: 41.99779248419691,
    y2: 179.27096708227145
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "118.106957765738116 128.720727391351829 118.106957765738116 155.256159868902614 118.106957765738116 185.227865260882027"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M121.045196674869658,126.088296286850891c.082820200865172-2.227079267839144,1.144917744406484-14.543954021579339,14.510446575051901-14.332335726288875,.183981073250834,.002912998170359,.336944164189845,.150345653259137,.342768194819655,.334257592880022,.070090459299536,2.213324954840573-.15205018963934,14.908802569008913-14.517535247379783,14.356456375799098-.190934649861447-.007341348140471-.342780302313258-.167434494569534-.335679522491773-.358378242390245Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M122.444238679679984,151.082125466122307c.106962962294347-2.876290968421017,1.478670568843881-18.783634781870205,18.740359642461044-18.510328034210033,.237613050850996,.003762160809856,.435166125560499,.194172632678601,.442687908431253,.431696396899497,.090522397649693,2.85852716143927-.196374055260094,19.254839645120228-18.749514720353545,18.54148004901981-.246593651552757-.009481410770604-.442703545373661-.216243010070684-.433532830538752-.462848411709274Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 122.44392966263695,
    y1: 151.5675663771508,
    x2: 118.10695776573812,
    y2: 155.96693116449205
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 121.10000788403704,
    y1: 126.27487687284156,
    x2: 118.10695776573812,
    y2: 128.72072739135183
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.16871885659566,126.088296286850891c-.082820200865172-2.227079267839144-1.144917744406484-14.543954021579339-14.510446575055539-14.332335726288875-.183981073229006,.002912998170359-.336944164188026,.150345653259137-.342768194805103,.334257592880022-.070090459314088,2.213324954840573,.152050189624788,14.908802569008913,14.517535247368869,14.356456375799098,.190934649859628-.007341348140471,.342780302315077-.167434494569534,.335679522491773-.358378242390245Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M113.769676851785334,151.082125466122307c-.106962962296166-2.876290968421017-1.478670568832968-18.783634781870205-18.740359642444673-18.510328034210033-.237613050854634,.003762160809856-.435166125569594,.194172632678601-.442687908434891,.431696396899497-.090522397658788,2.85852716143927,.196374055247361,19.254839645120228,18.749514720340812,18.54148004901981,.246593651550938-.009481410770604,.442703545373661-.216243010070684,.433532830538752-.462848411709274Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 113.76998586883747,
    y1: 151.5675663771508,
    x2: 118.10695776572538,
    y2: 155.96693116449205
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 115.11390764742828,
    y1: 126.27487687284156,
    x2: 118.10695776572538,
    y2: 128.72072739135183
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.273272090005776,96.790728053190833l5.32331341482859-5.321741769868822c.281870812825218-.281787593830813,.738806236677192-.281720121540275,1.020593818213456,.000150703590407l5.320019465829319,5.321591066278415"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 118.10523543943418,
    y1: 107.94435795898244,
    x2: 118.10523543943418,
    y2: 91.50628631615109
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.3847171983598,
    y1: 153.38741895549174,
    x2: 77.3847171983598,
    y2: 185.22786526088203
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 73.31314989697057,
    y1: 164.13320436097092,
    x2: 77.3847171983598,
    y2: 166.89205908653094
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 81.45628449974538,
    y1: 164.13320436097092,
    x2: 77.3847171983598,
    y2: 166.89205908653094
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M81.439189068491032,163.567602780130983c.228146532728715-1.643157336578952,1.937275178044729-10.685403794499507,11.819849863270065-9.527589417608397,.136037018812203,.015937710688377,.238277654390913,.136582476949116,.228815709486298,.273222707868626-.113871665005718,1.644424138879913-1.229291336181632,11.029975047369589-11.826906348935154,9.544922067751031-.140855105391893-.019738148041142-.241319889950319-.149675495920746-.221759223821209-.290555358011261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.962922408400118,163.567602780130983c-.228146532728715-1.643157336578952-1.93727517804291-10.685403794499507-11.819849863268246-9.527589417608397-.136037018812203,.015937710688377-.238277654392732,.136582476949116-.228815709486298,.273222707868626,.113871665005718,1.644424138879913,1.229291336179813,11.029975047369589,11.826906348935154,9.544922067751031,.140855105390074-.019738148041142,.241319889950319-.149675495920746,.22175922381939-.290555358011261Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M77.633583950739194,153.752060165501462c1.475440058842651-1.430193397609401,9.262849890221332-9.75392916913006,.875362774793757-18.784606798679306-.115456627328967-.124310364641133-.310843276911328-.138235609250842-.440494325277541-.028810268469897-1.560311425997497,1.31690111008902-10.125224432104005,9.29838426455899-.887524336907518,18.804340663769835,.122780193363724,.126345643699096,.326155650687724,.131697313820041,.452655887391302,.009076403379368Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71.552319998905659,119.578923610100901l5.323313414817676-5.321741769868822c.281870812836132-.281787593830813,.738806236679011-.28172012153118,1.020593818226189,.000150703588588l5.3200194658275,5.321591066280234"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 77.38428334833498,
    y1: 130.7325535159016,
    x2: 77.38428334833498,
    y2: 114.29448187306116
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.165829134759406,150.285762884481301l5.323313414824952-5.321741769870641c.281870812836132-.281787593828994,.738806236684468-.281720121529361,1.020593818221641,.000150703590407l5.32001946582659,5.321591066280234"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 41.99779248419691,
    y1: 161.43939279027109,
    x2: 41.99779248419691,
    y2: 145.00132114744156
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 77.3847171983598,
    cy: 39.23388575400986,
    r: 18.709384675724774
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.3847171983598,
    y1: 39.17040352393087,
    x2: 77.3847171983598,
    y2: 31.671012595292268
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 77.3847171983598,
    y1: 39.17040352393087,
    x2: 73.78860566698313,
    y2: 42.32270472865093
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 110.81794526174235,
    y1: 71.91676949989233,
    x2: 82.89348804259134,
    y2: 71.91676949989233
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.81144400692938,
    y1: 71.91676949989233,
    x2: 70.7359012260913,
    y2: 71.91676949989233
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 76.81469463434132,
    cy: 71.91676949989233,
    r: 5.69886882023593
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36.732650598677765,
    cy: 71.91676949989233,
    r: 5.698868820238545
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 116.89673867000056,
    cy: 71.91676949989233,
    r: 5.698868820238204
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "g649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path651",
    className: "cls-3",
    d: "M228.370686254382235,102.195040016922576v8.281279051259844c0,1.914918672979184-1.55234830037989,3.467266973359074-3.467266973360893,3.467266973359074h-63.55674220093897c-1.914918672981003,0-3.467266973360893-1.55234830037989-3.467266973360893-3.467266973359074v-45.933923164040607c0-1.914918672979184,1.55234830037989-3.467266973360893,3.467266973360893-3.467266973360893h63.55674220093897c1.914918672981003,0,3.467266973360893,1.552348300381709,3.467266973360893,3.467266973360893v37.652644112780763Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path655",
    className: "cls-3",
    d: "M193.125048180550948,113.943586041541494v71.284279219340533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path707",
    className: "cls-3",
    d: "M157.87941010672148,102.195040016922576h70.491276147660756"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 211.4203726511023,
    y1: 77.0939788288415,
    x2: 197.17130282524158,
    y2: 77.0939788288415
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 176.7185563405019,
    y1: 77.0939788288415,
    x2: 190.9676261663626,
    y2: 77.0939788288415
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 194.06946449579664,
    cy: 77.0939788288415,
    r: 2.907973433852931
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 173.61671801106922,
    cy: 77.0939788288415,
    r: 2.907973433846792
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 214.52221098053087,
    cy: 77.0939788288415,
    r: 2.907973433850202
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 171.15948990178185,
    y1: 87.50935748616212,
    x2: 178.47039648261125,
    y2: 87.50935748616212
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 170.99765993841174,
    y1: 92.42688711423216,
    x2: 175.25283603428215,
    y2: 92.42688711423216
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 191.3233210253311,
    y1: 87.50935748616212,
    x2: 198.6342276061623,
    y2: 87.50935748616212
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 191.1614910619519,
    y1: 92.42688711423216,
    x2: 195.4166671578223,
    y2: 92.42688711423216
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 211.48715214887125,
    y1: 87.50935748616212,
    x2: 218.79805872969155,
    y2: 87.50935748616212
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 211.32532218549204,
    y1: 92.42688711423216,
    x2: 215.58049828137155,
    y2: 92.42688711423216
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo03);
export default __webpack_public_path__ + "static/media/logo03.ef6e0f91e0fa784d13b973cea9c7cc68.svg";
export { ForwardRef as ReactComponent };